import { BetIF } from './types'

export const getAccountName = (website: string) =>
    new RegExp(/https?:\/\/(?:www\.)?([a-zA-Z0-9-.]+)\./).exec(website)?.[1] ??
    website

export const getMaxBloodRiskAmount = (amount: number, line: number) => {
    if (line < 0) {
        return roundToHundreths((amount * Math.abs(line)) / 100)
    }
    return amount
}

export const roundToHundreths = (num: number): number => Math.round(num * 100) / 100

export const getWinningAmount = (bet: BetIF) => {
    // Formula for positive odds = (odds / 100) * amount risked
    // Formula for negative odds = (100 / odds) * amount risked

    if (bet.outcomeAmount) return bet.outcomeAmount

    if (bet.realOddsLine && bet.riskAmount) {
        if (bet.realOddsLine > 0) {
            return roundToHundreths((bet.realOddsLine / 100) * bet.riskAmount)
        } else if (bet.realOddsLine < 0) {
            return roundToHundreths((100 / (bet.realOddsLine * -1)) * bet.riskAmount)
        } else {
            // who tf bets 0;
            return bet.riskAmount
        }
    }

    if (bet.amount && bet.realOddsLine) {
        if (bet.realOddsLine > 0) {
            return roundToHundreths((bet.realOddsLine / 100) * bet.amount)
        } else {
            return bet.amount // Assume max blood risk
        }
    }

    if (bet.amount) return bet.amount // Assume max blood risk

    return 0
}

export const getLosingAmount = (bet: BetIF) => {
    if (bet.outcomeAmount) return bet.outcomeAmount
    if (bet.riskAmount) return bet.riskAmount

    if (bet.amount && bet.realOddsLine) {
        if (bet.realOddsLine > 0) {
            return bet.amount;
        } else {
            return getMaxBloodRiskAmount(bet.amount, bet.realOddsLine);
        }
    }

    return 0
}

export const formatNumber = (number: number) => {
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    })
    return formatter.format(number)
}

export const formatTeam = (awayTeam: string, homeTeam?: string) =>
    `${awayTeam}${homeTeam ? ` @ ${homeTeam}` : ''}`
